// src/services/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://centroanaliticodepatologia.com.mx/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

export default api;
